'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*  weak */
function debugLayout(style, meta, options) {
  if (meta.type === 'rule') {
    var ruleName = meta.rule.name || 'foobar';
    var color = (ruleName + ruleName).length * 17 * ruleName.length;

    if (options.backgroundColor) {
      style.backgroundColor = 'hsla(' + color + ', 100%, 25%, 0.1) !important';
    } else {
      style.outline = options.thickness + 'px solid hsl(' + color + ', 100%, 50%) !important';
    }
  }

  return style;
}

var defaultOptions = { backgroundColor: false, thickness: 1 };

exports.default = function (options) {
  return function (style, meta) {
    return debugLayout(style, meta, _extends({}, defaultOptions, options));
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/plugins/debugLayout.js
// module id = 448
// module chunks = 0